import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Marker, Popup } from 'react-map-gl';

import Icons from '../../../utils/Icons';
import PinMarker from '../../../models/PinMarker';
import Analytics from '../../../utils/analytics';

const getHoveredIcon = (isFavorite, isAdditional) => {
    if (isAdditional) {
        return isFavorite
            ? PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME_HOVER
            : PinMarker.ICON.UNAVAILABLE_HOME_HOVER;
    } else {
        return isFavorite ? PinMarker.ICON.FAVORITE_HOME_HOVER : PinMarker.ICON.AVAILABLE_HOME_HOVER;
    }
};

const getNotHoveredIcon = (isFavorite, isAdditional) => {
    if (isAdditional) {
        return isFavorite ? PinMarker.ICON.UNAVAILABLE_FAVORITE_HOME : PinMarker.ICON.UNAVAILABLE_HOME;
    } else {
        return isFavorite ? PinMarker.ICON.FAVORITE_HOME : PinMarker.ICON.AVAILABLE_HOME;
    }
};

const getMarkerIcon = (isFavorite, hover, isAdditional) =>
    hover ? getHoveredIcon(isFavorite, isAdditional) : getNotHoveredIcon(isFavorite, isAdditional);

const newStyle = (size, index) => {
    return { zIndex: index, fontSize: `${size}px` };
};

const defineIconCustomSize = (isFavorite, hover, isAdditional) => {
    if (hover) {
        return PinMarker.isFavoriteHomeIcon(getMarkerIcon(isFavorite, hover, isAdditional).class)
            ? newStyle(45, 1)
            : newStyle(36, 1);
    } else {
        return PinMarker.isFavoriteHomeIcon(getMarkerIcon(isFavorite, hover, isAdditional).class)
            ? newStyle(40, 0)
            : newStyle(31, 0);
    }
};

const CustomMarker = ({
    latitude,
    longitude,
    popupContent,
    isFavorite,
    isAdditional = false,
    isSelected = false
}) => {
    const [openPopup, setOpenPopup] = useState(false);
    const [customStyle, setCustomStyle] = useState(newStyle(31, 0));
    const [imgSrc, setImgSrc] = useState(defineIconCustomSize(isFavorite, false, isAdditional));
    const [isHover, setIsHover] = useState(isSelected);

    const mapPinContainer = useRef(null);

    useEffect(() => {
        if (isHover) {
            setImgSrc(getMarkerIcon(isFavorite, true, isAdditional));
            setCustomStyle(defineIconCustomSize(isFavorite, isHover, isAdditional));
        } else {
            setImgSrc(getMarkerIcon(isFavorite, false, isAdditional));
            setCustomStyle(defineIconCustomSize(isFavorite, isHover, isAdditional));
        }
    }, [isHover]);

    useEffect(() => {
        setIsHover(isSelected);
    }, [isSelected]);

    const openPinContextPopin = (e) => {
        e.originalEvent.stopPropagation();
        setOpenPopup(true);

        const eventData = {
            action: 'click',
            text: mapPinContainer.current?.getAttribute('data-pin-name'),
            area: 'search_page_map'
        };

        Analytics.trackGTM('SearchMap', { event_data: eventData });
    };

    return (
        <>
            <Marker
                onClick={openPinContextPopin}
                latitude={latitude}
                longitude={longitude}
                style={{ zIndex: customStyle.zIndex }}
            >
                <span
                    data-pin-name={PinMarker.getMarkerTrackingId(imgSrc.name)}
                    ref={mapPinContainer}
                    className={imgSrc.class}
                    style={{ fontSize: customStyle.fontSize, width: 'auto' }}
                    onMouseEnter={() => setIsHover(true)}
                    onMouseLeave={() => setIsHover(false)}
                >
                    {Icons.transform(PinMarker.getPathMarker(imgSrc.class))}
                </span>
            </Marker>
            {openPopup && (
                <Popup
                    latitude={latitude}
                    longitude={longitude}
                    onClose={() => setOpenPopup(false)}
                    style={{ zIndex: 2 }}
                    className="slideUp"
                >
                    {popupContent}
                </Popup>
            )}
        </>
    );
};

CustomMarker.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
    popupContent: PropTypes.any,
    isSelected: PropTypes.bool,
    isAdditional: PropTypes.bool,
    isFavorite: PropTypes.bool
};

export default CustomMarker;
